import { render, staticRenderFns } from "./mobile-category-list.vue?vue&type=template&id=3616f48a&lang=pug&"
import script from "./mobile-category-list.vue?vue&type=script&lang=js&"
export * from "./mobile-category-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports